import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';

export const CustomTextField = ({ label, field, control }) => {
  return (
    <Controller
      name={field}
      control={control}
      render={({ field: { onChange, value } }) => (
        <TextField
          label={label}
          size="small"
          value={value || ''}
          onChange={e => {
            const newValue = e.target.value;
            onChange(newValue);
          }}
        />
      )}
    />
  );
};
